import React, { useState } from "react";
import { REPORT_MIN_MATCHES, isReportUnlocked } from "../reportGate";
import ActiveBuyerReportComingSoonModal from "../../../components/Common/ActiveBuyerReportComingSoonModal";
import "./ReportCTA.scss";

export { REPORT_MIN_MATCHES };

// Temporary kill switch: force the coming-soon modal for every property,
// regardless of match count, until the report is ready to launch for real.
// Flip back to true to restore the normal unlock-at-REPORT_MIN_MATCHES gating.
const REPORT_ENABLED = false;

const ChartIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
    <path d="M3 3v18h18" />
    <rect x="7" y="12" width="3" height="6" rx="0.5" />
    <rect x="12" y="8" width="3" height="10" rx="0.5" />
    <rect x="17" y="5" width="3" height="13" rx="0.5" />
  </svg>
);

const ReportCTA = ({ inventoryId, totalMatches = 0, editMode = true }) => {
  const [showComingSoon, setShowComingSoon] = useState(false);
  const unlocked = REPORT_ENABLED && isReportUnlocked(totalMatches);

  const openReport = () => {
    if (!inventoryId) return;
    const url = editMode
      ? `/reports/active-buyer/${inventoryId}?edit=1`
      : `/reports/active-buyer/${inventoryId}`;
    window.open(url, "_blank", "noopener,noreferrer");
  };

  if (unlocked) {
    return (
      <button
        type="button"
        className="abr-entry-cta abr-entry-cta--ready"
        onClick={openReport}
        data-tour="download-report"
      >
        <ChartIcon />
        Generate Active Buyer Report
      </button>
    );
  }

  return (
    <>
      <button
        type="button"
        className="abr-entry-cta abr-entry-cta--soon"
        data-tour="download-report"
        onClick={() => setShowComingSoon(true)}
      >
        <ChartIcon />
        Active Buyer Report
      </button>
      <ActiveBuyerReportComingSoonModal
        show={showComingSoon}
        onHide={() => setShowComingSoon(false)}
      />
    </>
  );
};

export default ReportCTA;
